var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUncheckCircle = function SvgUncheckCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.2.3.0-Queue-/-Subsidy-and-billable-normal---default",
    transform: "translate(-785.000000, -343.500000)",
    fill: "#F1F1F1",
    stroke: "#E1E1E1",
    strokeWidth: 0.666666667
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right",
    transform: "translate(769.000000, 164.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Package--expand",
    transform: "translate(0.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Package",
    transform: "translate(0.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Test-1",
    transform: "translate(16.000000, 97.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02.Atoms/03.Select/02.Circle/24/Default",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.333333333,
    y: 0.333333333,
    width: 15.3333333,
    height: 15.3333333,
    rx: 7.66666667
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUncheckCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/uncheck-circle.3466b4c7.svg";
export { ForwardRef as ReactComponent };